import { noop } from 'lodash';
import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

import { getUserTrialType, useAuthStore } from '@revelio/auth';
import {
  calcTrialDay,
  type MixpanelUser,
  setUserEventListener,
  UserTrackingEvents,
  userTracking,
} from '@revelio/core';

import packageJson from '../../../package.json';
import { useOpenReplay } from '../../hooks/open-replay';

export const useUserTracking = () => {
  const { ory, user } = useAuthStore();
  const userId = ory?.id ?? '';
  const username = ory?.username ?? '';
  const clientName = user?.client_name;

  const accountCreatedAt = ory?.account_created_at;
  const { tracker } = useOpenReplay();

  useEffect(() => {
    tracker.setUserID(username);
    if (clientName) tracker.setMetadata('client', clientName);
    tracker.setMetadata('version', packageJson.version);
    const trialType = user ? getUserTrialType(user) : false;
    tracker.setMetadata('trial', trialType === false ? 'false' : trialType);

    const mixpanelUser: MixpanelUser = {
      id: userId,
      client_name: clientName ?? 'Unknown',
      username,
      trial: !user?.live,
      ...(accountCreatedAt && { trial_day: calcTrialDay(accountCreatedAt) }),
    };
    userTracking.setUser(mixpanelUser);
    userTracking.track(UserTrackingEvents.SESSION);
  }, [userId, clientName, username, user, tracker, accountCreatedAt]);

  useEffect(() => {
    setUserEventListener((event) => {
      mixpanel.track(event);
    });
    return () => {
      setUserEventListener(noop);
    };
  }, []);
};
